import { render, staticRenderFns } from "./DiscountMemberList.vue?vue&type=template&id=5005d542&"
import script from "./DiscountMemberList.vue?vue&type=script&lang=js&"
export * from "./DiscountMemberList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports